export enum VehicleType {
  VanSmall = "VAN_SMALL",
  VanLarge = "VAN_LARGE",
  BoxVan = "BOX_VAN",
  Rigid75 = "RIGID_75",
  Rigid12 = "RIGID_12",
  Rigid18 = "RIGID_18",
  TractorTrailer = "TRACTOR_TRAILER",
  TractorUnit = "TRACTOR_UNIT"
}

export const displayStringForVehicleType = (type: VehicleType): string => {
  switch (type) {
    case VehicleType.VanSmall:
      return "Bus (klein)";
    case VehicleType.VanLarge:
      return "Bus (groß)";
    case VehicleType.BoxVan:
      return "Bus (Aufbau)";
    case VehicleType.Rigid75:
      return "7,5 Tonner";
    case VehicleType.Rigid12:
      return "12 Tonner";
    case VehicleType.Rigid18:
      return "18 Tonner";
    case VehicleType.TractorTrailer:
      return "Sattelzug";
    case VehicleType.TractorUnit:
      return "Zugmaschine";
    default:
      return type;
  }
};
